import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { guideMarkdownToText } from '@backrs_ui/grow-ui/src/components/GuidePage';
import {
  CollegeVisitContrastList,
  collegeVisitGuideContent,
} from '@backrs_ui/grow-ui/src/pages/CollegeVisitGuide/content';

const { header, mindset, before, during, after } = collegeVisitGuideContent;

const listDetail = (list: CollegeVisitContrastList): string =>
  [list.label, ...list.items.map((item) => `- ${item}`)].join('\n');

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: header.title,
    description:
      'Overview of the College Visit Guide and the five areas of fit to assess on every visit.',
    detail: [
      ...header.description,
      ...mindset.fits.map((fit) => `${fit.number}. ${fit.title}: ${fit.body}`),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: before.title,
    description: 'Pre-visit checklist, admissions strategy, and pro tips.',
    detail: [
      before.checklist.title,
      ...before.checklist.items.map((item) => `- ${item}`),
      before.admissionsStrategy.subtitle,
      listDetail(before.admissionsStrategy.doList),
      listDetail(before.admissionsStrategy.dontList),
      before.proTips.title,
      ...before.proTips.tips.map(
        (tip) => `${tip.number}. ${tip.title} (${tip.source}): ${tip.body}`,
      ),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: during.title,
    description: 'High-yield visit activities and common traps.',
    detail: [
      during.activities.subtitle,
      listDetail(during.activities.highYield),
      listDetail(during.activities.commonTraps),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: during.overnight.title,
    description: 'How to request and get the most out of an overnight campus visit.',
    detail: [
      during.overnight.subtitle,
      ...during.overnight.steps.map((step) => `${step.number}. ${step.title}: ${step.body}`),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: after.title,
    description: 'Follow-up email template to send after a campus visit.',
    detail: [
      after.followUpEmail.title,
      ...after.followUpEmail.template.map(guideMarkdownToText),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: after.discernment.title,
    description: 'Framework for comparing school types and learning your own preferences.',
    detail: [
      after.discernment.subtitle,
      ...after.discernment.comparisons.map((comparison) =>
        [
          comparison.title,
          `${comparison.left.label}: ${comparison.left.points.join('; ')}`,
          `${comparison.right.label}: ${comparison.right.points.join('; ')}`,
        ].join('\n'),
      ),
    ].join('\n'),
  });
};
